import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DATE_SHORT_FORMAT, ROLE_OrderFAA } from '../../constants';
import moment from 'moment';
import TextViewControl from '../common/TextViewControl';

class AwningColorbondHoodSheet extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      awning: props.awning,
    };

    this.getCurrentState = this.getCurrentState.bind(this);
  }

  getCurrentState(){
    return this.state.awning;
  }

  render() {
    let {order, colorBondColours, isFabricationOrder, user} = this.props;
    let {awning} = this.state;

    if (!awning || !(awning.id > 0)) {
      return null;
    }

    let colourMatch = colorBondColours && colorBondColours.filter(x => x.value === awning.colorbondHoodColourId)[0];
    let colourLabel = colourMatch ? colourMatch.label : 'Not selected';
    let length = (awning.width || 0) + 20;

    return (
      <div>
        <div className="pi-row" style={{paddingTop: '25px', fontSize: 'larger'}}>
          <div className="pi-col-sm-12">

            <div className="pi-row">
              <div className="pi-col-md-8">
                <TextViewControl
                  labelText="Order"
                  value={`${order.customerReference}.${awning.number}`}
                  boldLabel={true}
                />
                <TextViewControl
                  labelText="Date"
                  value={moment().format(DATE_SHORT_FORMAT)}
                  boldLabel={true}
                />
                {isFabricationOrder && user && !user.isInRole(ROLE_OrderFAA) && <TextViewControl
                  labelText="To"
                  value={`To be sourced independently of ${order.organisationGroupShortName || ''}`}
                  boldLabel={true}
                />}
              </div>
              <div className="pi-col-md-4">
                <img src={this.props.theme.data.images.logoFull} alt="Logo" style={{maxWidth: '60%'}} />
              </div>
            </div>

            <div className="pi-row">
              <div className="pi-col-md-8">
                <TextViewControl
                  labelText="Finish"
                  value={colourLabel}
                  boldLabel={true}
                />
                <TextViewControl
                  labelText="Length"
                  value={`${length}mm`}
                  boldLabel={true}
                />
              </div>
            </div>

            <div className="pi-row">
              <div className="pi-col-md-12">
                <img src='img/colorbond-hood.png' alt="FAA Colorbond Hood" style={{marginTop: '50px', maxWidth: '100%'}} />
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

AwningColorbondHoodSheet.propTypes = {
  awning: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  colorBondColours: PropTypes.array.isRequired,
  theme: PropTypes.object.isRequired,
  isFabricationOrder: PropTypes.bool,
  user: PropTypes.object,
};

export default AwningColorbondHoodSheet;
